import { FC, useContext, useEffect } from "react";
import { IFooterProps, Footer } from "../footer/index";
import { INavBarProps, NavBar } from "../navbar/index";
import { IEnFooterProps, EnFooter } from "../en/footer/index";
import { IEnNavBarProps, EnNavBar } from "../en/navbar/index";
import styles from "./styles.module.scss";
import { IndexContext } from "@/stores";
import { useRouter } from "next/router";

export interface ILayoutProps {
  navbarData: INavBarProps;
  footerData: IFooterProps;
  enNavbarData: IEnNavBarProps;
  enFooterData: IEnFooterProps;
}

export const Layout: FC<ILayoutProps & { children: JSX.Element }> = ({
  navbarData,
  footerData,
  enNavbarData,
  enFooterData,
  children,
}) => {
  const { lang, isHeadFoot } = useContext(IndexContext);
  const router = useRouter()

  return (
    <div className={styles.layout}>
      {
        isHeadFoot &&
        (lang === 'cn' ? <NavBar {...navbarData} /> : <EnNavBar {...enNavbarData} />)
      }
      <main className={styles.main}
        style={{ backgroundColor: isHeadFoot ? 'white' : 'black' }}>{children}</main>
      {
        isHeadFoot &&
        (lang === 'cn' ? <Footer {...footerData} /> : <EnFooter {...enFooterData} />)}
    </div>
  );
};
